/**
 * Internal Error page.
 * Shown when an unexpected error occurs.
 *
 * @module pages/internalError
 */

import React              from 'react';
import Layout             from '../components/Layout';
import UnderConstruction  from '../components/UnderConstruction';
import { useI18n }        from '../dataProviders/I18nProvider';

/**
 * Renders the Internal Error placeholder page.
 *
 * @returns {React.ReactElement}
 */
export default function InternalError() {
  const { t } = useI18n();

  return (
    <Layout title={t('page.internalError')}>
      <UnderConstruction />
    </Layout>
  );
}
